import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { LazyImageProvider } from 'trellis-ecosystem';
import { SuggestedCollections } from '../../collections/components/SuggestedCollections';
import { APPS_SUGGESTED_COLLECTION_IDS } from '../../collections/constants/collections';
import { AllProductsSection } from '../../components/AllProductsSection';
import { SliderSection } from '../../components/SliderSection';
import { PageCalloutBannerCard } from '../../hero/components/PageCalloutBannerCard';
import { getPageCollectionPreviews, useCurrentPageId, usePageCalloutBanners, usePagePlacements } from '../../hero/hooks/usePagePlacements';
import { useGates } from '../../hooks/useGates';
import { AgentFeaturedCollectionSection } from './AgentFeaturedCollectionSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductHomeSections({
  error,
  featuredCollectionId,
  loading,
  productType,
  remainingSections,
  sections
}) {
  const totalSectionsLength = sections.length + remainingSections.length + 2;
  const gates = useGates();
  const pageId = useCurrentPageId();
  const useLivePlacements = gates.newDashboard;
  const banners = usePageCalloutBanners();
  const {
    placementsBySection,
    loading: placementsLoading,
    error: placementsError
  } = usePagePlacements(useLivePlacements ? pageId : undefined);
  const interleavedBanner = useLivePlacements ? banners[0] : undefined;
  const pageCollectionPreviews = getPageCollectionPreviews(placementsBySection, pageId);
  if (loading || useLivePlacements && placementsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    });
  }
  if (error || useLivePlacements && placementsError) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  }
  return /*#__PURE__*/_jsx(LazyImageProvider, {
    children: /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      children: [sections === null || sections === void 0 ? void 0 : sections.map((section, index) => {
        var _section$contexts;
        return /*#__PURE__*/_jsx(SliderSection, {
          cards: section.cards,
          context: (_section$contexts = section.contexts) === null || _section$contexts === void 0 ? void 0 : _section$contexts[0],
          productType: productType,
          sectionIndex: index,
          sectionType: section.sectionType,
          title: section.title
        }, index);
      }), useLivePlacements ? pageCollectionPreviews.length > 0 && /*#__PURE__*/_jsx(SuggestedCollections, {
        placementCollections: pageCollectionPreviews
      }) : productType === 'AGENT' ? /*#__PURE__*/_jsx(AgentFeaturedCollectionSection, {
        featuredCollectionId: featuredCollectionId,
        sectionCount: totalSectionsLength,
        sectionIndex: sections.length
      }) : productType === 'APP' ? /*#__PURE__*/_jsx(SuggestedCollections, {
        collectionIds: APPS_SUGGESTED_COLLECTION_IDS
      }) : null, interleavedBanner && /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "1200",
        children: /*#__PURE__*/_jsx(PageCalloutBannerCard, {
          placement: interleavedBanner
        })
      }), remainingSections === null || remainingSections === void 0 ? void 0 : remainingSections.map((section, index) => {
        var _section$contexts2;
        return /*#__PURE__*/_jsx(SliderSection, {
          cards: section.cards,
          context: (_section$contexts2 = section.contexts) === null || _section$contexts2 === void 0 ? void 0 : _section$contexts2[0],
          productType: productType,
          sectionIndex: sections.length + index + 1,
          sectionType: section.sectionType,
          title: section.title
        }, index);
      }), /*#__PURE__*/_jsx(AllProductsSection, {
        productType: productType,
        sectionIndex: totalSectionsLength
      })]
    })
  });
}